var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAccentVolumeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.164 13.07c2.507 3.98 2.861 9.28.476 13.968m-5.759-11.364c2.117 2.474 2.416 5.767.402 8.68M19 9.777l-6.986 5.524H4.75v7.952l7.264-.002L19 28.777v-19z",
    stroke: "#10121C",
    strokeWidth: 3.201,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccentVolumeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AccentVolumeIcon.479aaba9.svg";
export { ForwardRef as ReactComponent };